import { useTranslation } from 'react-i18next';
import SelectField from 'components/forms/selectField/SelectField';
import { RoomType } from 'models/PropertyRooms';
import useFetchRoomTypeOptions from './useFetchRoomTypeOptions';

const RoomsAndBedTypesFormRoomTypeField = ({
  roomIndex,
  update,
  isEditing,
}: {
  roomIndex: number;
  update: (roomIndex: number, roomType: RoomType) => void;
  isEditing: boolean;
}) => {
  const { data: roomTypeOptions, isInitialLoading: isFetchingRoomTypeOptions } =
    useFetchRoomTypeOptions({ enabled: true });
  const { t } = useTranslation();

  const optionsWithValue = (roomTypeOptions ?? [])
    .map(({ roomType }) => ({
      label: t(`componentProperty.rooms.roomType.${roomType}`),
      value: roomType,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  return (
    <SelectField
      label={t(
        'pageProperty.mainSettings.capacityDetails.setRoomsAndBedTypesModal.roomType',
      )}
      name={`rooms.${roomIndex}.roomType`}
      onChangeHandler={(e) => {
        if (isEditing) {
          return;
        }
        update(roomIndex, (e.target as HTMLSelectElement).value as RoomType);
      }}
      isLoading={isFetchingRoomTypeOptions}
      options={optionsWithValue}
      colSmLabel={5}
      colSmInput={7}
      disabled={isEditing}
    />
  );
};

export default RoomsAndBedTypesFormRoomTypeField;
